import React from "react";
import Button from "react-bootstrap/es/Button";

class PolygonGrid {
  title = 'Polígonos';
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName"
    },
    {
      Header: "Camada",
      accessor: "layer"
    },
    {
      Header: "Pontos",
      Cell: row => {
        return row.original.points.map(({x, y}, index) =>
            <div key={index}>
              <b>X:</b> {x} &nbsp;&nbsp; <b>Y:</b> {y}
            </div>
        )
      }
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <a href={"#/polygons/" + row.original.id + '/edit'}>
            <Button bsStyle="success" block>Editar</Button>
          </a>
      ),
    }
  ];

  newUrl = function (props, state) {
    const id = props.match.params.id;
    return `/maps/${id}/polygons/new`;
  };

  endpoint = function (props, state) {
    const id = props.match.params.id;
    return `polygon/v1/maps/${id}/polygons`;
  };
}

export default PolygonGrid;



// WEBPACK FOOTER //
// ./src/map/polygon/PolygonGrid.js